export default __webpack_public_path__ + "static/media/7.99d3c45b.jpeg";